module.exports = __webpack_public_path__ + "f9ddcc989c600e12891925abc718ae0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/23.jpg
// module id = 1350
// module chunks = 47